import { createContext, useContext } from 'react';

// marketplace-ui-tracking depends on marketplace-ui-common, so importing its types here
// would create a circular dependency. These local types are structurally compatible with
// MarketplaceInteraction and Partial<InstallButtonClicked> from marketplace-ui-tracking —
// the full tracking types are still enforced at the useTracking level in marketplace-ui-install.
export const DetailsPageContext = /*#__PURE__*/createContext({
  appContext: 'app',
  displayTag: undefined,
  iconUrl: '',
  listingId: 0,
  listingIdV2: 0,
  // TODO - deprecate --- this is still needed for sendAdminEmail
  previewListingId: undefined,
  name: '',
  productType: 'APP',
  published: true,
  runLeadGen: () => {},
  trackInteraction: () => {},
  trackInstall: () => {},
  userInfo: {},
  isEmbedded: false,
  isBreezeConnector: false,
  isMcpConnector: false,
  isMcpServer: false,
  worksWithBreeze: false
});
export const useDetailsPageContext = () => {
  const context = useContext(DetailsPageContext);
  if (!context) {
    throw new Error('useDetailsPageContext must be used within a DetailsPageContext.Provider');
  }
  return context;
};